import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useWatch } from 'react-hook-form';

import { getNumberOfGuests } from 'reservations/booking/helpers';
import { FormHeader } from 'reservations/form/components/FormHeader';
import { getFormattedPositionInLine } from 'reservations/waitlist/helpers/getFormattedPositionInLine';
import { useWaitlist } from 'reservations/waitlist/providers/WaitlistProvider';

const JoinTheWaitlistFormHeader = () => {
  const { waitCount } = useWaitlist();
  const partySize = useWatch({
    name: 'partySize'
  });

  return (
    <Box>
      <FormHeader />
      <Typography sx={{ fontWeight: 500, fontSize: '16px', mt: '8px' }}>
        {getNumberOfGuests(partySize)}
      </Typography>
      <Typography sx={{ fontWeight: 500, fontSize: '16px' }}>
        You&apos;ll be <strong>{getFormattedPositionInLine(waitCount)}</strong>{' '}
        in line.
      </Typography>
    </Box>
  );
};

export default JoinTheWaitlistFormHeader;
